<template lang="pug">
    .about-breadcrumbs
        .container
            .row
                .col-md-12
                    router-link(:to="this.lang == 'EN'? '/en' : '/es'") {{ this.lang == 'EN'? 'HOME' : 'INICIO' }}
                    i.fas.fa-chevron-right
                    router-link(:to="view.link") {{ view.name }}
                    i.fas.fa-chevron-right
                    span {{ section }}
</template>

<script>
export default {
    props: ['view', 'section', 'lang']
}
</script>

<style lang="scss" scoped>
    .about-breadcrumbs{
        padding-top: 17px;
        a, span{
            padding-right: 5px;
            padding-left: 5px;
        }
        a{
            color:rgba(255,255,255,.8)!important;
        }
        a:hover{
            text-decoration: underline;
        }
    }
</style>





// WEBPACK FOOTER //
// src/components/atoms/PmBreadCrumbs.vue